import styled from '@emotion/styled';
import lockClosed from '../images/lock-closed.svg';
import { media } from '../utilities/style-utils';
import React from 'react';
import { token } from '@atlaskit/tokens';

const baseSpacing = token('space.100');
const DefaultSecurityKeyContainer = styled.div`
  background: url(${lockClosed}) no-repeat center 0 / calc(${baseSpacing} * 14.5);
  min-width: 100%;
  margin-top: ${baseSpacing};
  padding-top: calc(${baseSpacing} * 18);

  box-sizing: border-box;

  ${media.handheld`
    background: 0;
    padding: 0;
  `}
`;

interface Props {
  children?: React.ReactNode;
  id?: string;
}

export const SecurityKey = ({ children, id }: Props) => {
  return <DefaultSecurityKeyContainer id={id}>{children}</DefaultSecurityKeyContainer>;
};
